/* eslint-disable max-len */
import type {SVGProps} from 'react';
import {forwardRef} from 'react';

export const FormatListNumberedNewIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props} ref={ref}>
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M2 11C2 10.4477 2.44772 10 3 10H4C4.55228 10 5 10.4477 5 11V11.4648C5 11.7992 4.8329 12.1114 4.5547 12.2969L3.5 13H4.5C4.77614 13 5 13.2239 5 13.5C5 13.7762 4.77614 14 4.5 14H2.66667C2.29848 14 2 13.7015 2 13.3333C2 13.1235 2.0988 12.9259 2.26667 12.8L4 11.5V11H3C3 11.2762 2.77614 11.5 2.5 11.5C2.22386 11.5 2 11.2762 2 11Z'
            fill='currentColor'
        />
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13H20C20.5523 13 21 12.5523 21 12C21 11.4477 20.5523 11 20 11H8ZM8 17C7.44772 17 7 17.4477 7 18C7 18.5523 7.44772 19 8 19H20C20.5523 19 21 18.5523 21 18C21 17.4477 20.5523 17 20 17H8ZM8 5.00001C7.44772 5.00001 7 5.44773 7 6.00001C7 6.5523 7.44772 7.00001 8 7.00001H20C20.5523 7.00001 21 6.5523 21 6.00001C21 5.44773 20.5523 5.00001 20 5.00001H8Z'
            fill='currentColor'
        />
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M3.31411 4.14647C3.62909 3.83149 4.16766 4.05457 4.16766 4.50003V7.5C4.16766 7.77615 3.9438 8.00001 3.66765 8.00001C3.3915 8.00001 3.16763 7.77614 3.16764 7.49999L3.16766 5.70713L2.87477 6.00003C2.67951 6.19529 2.36293 6.19529 2.16766 6.00003C1.9724 5.80476 1.9724 5.48818 2.16766 5.29292L3.31411 4.14647Z'
            fill='currentColor'
        />
        <path
            d='M4 16H3C2.44772 16 2 16.4477 2 17C2 17.2761 2.22386 17.5 2.5 17.5C2.77614 17.5 3 17.2761 3 17H4L4 17.5C3.25 17.5 3.25 17.8125 3.25 18C3.25 18.2761 3.25 18.5 4 18.5L4 19H3C3 18.7239 2.77614 18.5 2.5 18.5C2.22386 18.5 2 18.7239 2 19C2 19.5523 2.44772 20 3 20H4C4.55229 20 5 19.5523 5 19V18.5352C5 18.3269 4.93517 18.1272 4.81904 17.9614C4.92988 17.819 5 17.6528 5 17.4648V17C5 16.4477 4.55229 16 4 16Z'
            fill='currentColor'
        />
    </svg>
));
